import * as ResourceAuthAPI from '../../api/sitesee/resource';
export class AuthProvider {
}
export class ContainerAuthProvider extends AuthProvider {
    identProvider;
    get identityProvider() {
        return this.identProvider;
    }
    resProvider;
    get resourceProvider() {
        return this.resProvider;
    }
    constructor(identityProvider, resourceProvider) {
        super();
        this.identProvider = identityProvider;
        this.resProvider = resourceProvider;
    }
}
export class IdentityAuthProvider {
}
export class ResourceAuthProvider {
}
export class SessionStorageAuthProvider extends IdentityAuthProvider {
    getAuth() {
        if (!sessionStorage.getItem("jwt")) {
            return Promise.resolve({ token: undefined });
        }
        return Promise.resolve({ token: sessionStorage.getItem("jwt") });
    }
}
export class APIResourceAuthProvider extends ResourceAuthProvider {
    // authStore: AuthStore;
    appStateStore;
    constructor(appStateStore /* , authStore: AuthStore */) {
        super();
        this.appStateStore = appStateStore;
        // this.authStore = authStore;
    }
    async getAuth(resource, auth) {
        let activeGroupId = this.appStateStore.activeGroup ? this.appStateStore.activeGroup.id : '';
        if (!activeGroupId) {
            const result = await fetch(`${this.appStateStore.apiBasePath}/api/v1/users/me/defaultGroup`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${auth}`,
                }
            });
            const response = await result.json();
            const { id, displayName } = response.data;
            activeGroupId = id;
        }
        const { data } = await ResourceAuthAPI.getUserToken(this.appStateStore.apiBasePath, resource, auth, activeGroupId);
        return { token: data.resourceToken };
    }
}
//# sourceMappingURL=provider.js.map